import { paramCase } from 'change-case';

const convertCurrentRouteWithUnderscore = (route: string): string => {
	const viewName = route.substring(route.lastIndexOf('-') + 1);

	return route.replace(viewName, paramCase(viewName));
};

export const getTagName = (route: string): string => {
	const usedUnderscore = route.includes('_');

	return usedUnderscore ? convertCurrentRouteWithUnderscore(route) : paramCase(route);
};
